export function needsReducedHeight(height: number): boolean {
    return height < 330
}
export function needsReducedWidth(width: number): boolean {
    return width < 760
}
